import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as sesionService from "../../services/sesionService";
import { Grid, Card, CardContent, Typography, Box, Snackbar, Alert } from '@mui/material';
import Session from '../../components/Session'
import SessionTherapist from '../../components/SessionTherapist'
import SessionPlanArea from '../../components/SessionPlanArea'
import SessionCriterion from '../../components/SessionCriterion'
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';
import { activeValidations as activeValidationsSession } from '../../redux/sessionSlice';
import { setEntity as setSessionTherapist, activeValidations as activeSessionTherapist } from '../../redux/sessionTherapistSlice';
import { setEntity as setSessionCriterion, addDesdePlan as addSessionCriterionDesdePlan
    , activeValidations as activeSessionCriterion } from '../../redux/sessionCriterionSlice';

const Edit = (props) => {
  const session = useSelector((state) => state.session.entity);
  const nombreTerapeuta = useSelector((state) => state.session.nombreTerapeuta);
  const sessionTherapist = useSelector((state) => state.sessionTherapist.entity);
  const sessionCriterion = useSelector((state) => state.sessionCriterion.entity);
  const sessionValidation = useSelector((state) => state.session.validationMessage);
  const sessionTherapistValidation = useSelector((state) => state.sessionTherapist.validationMessage);
  const sessionCriterionValidation = useSelector((state) => state.sessionCriterion.validationMessage);
  const defaultSessionTherapist = useSelector((state) => state.sessionTherapist.defaultEntity)
  const defaultSessionCriterion = useSelector((state) => state.sessionCriterion.defaultEntity)
  // Terapia de la sesion: de ella sale el detalle de areas del plan que se
  // muestra en solo lectura. idPeriodo es el periodo Academico de la sesion:
  // con los dos se arma el filtro del Plan de Terapia.
  const idTerapia = useSelector((state) => state.session.entity.idTerapia);
  const idPeriodo = useSelector((state) => state.session.entity.idPeriodo);

  // Escala de avance del plan de la sesion: define los grupos de puntuacion
  // disponibles en el detalle de criterios.
  const [idPuntuacionSesion, setIdPuntuacionSesion] = useState(0);
  // Indicadores de detalle del plan de terapia de la sesion (Si/No). Si el plan
  // no pide el detalle de objetivo o de criterio, esos campos no se muestran en
  // el detalle de criterios. Sin plan quedan en null y cada criterio usa el
  // valor que heredo al crearse.
  const [detallePlan, setDetallePlan] = useState({ detObjetivo: null, detCriterio: null });
  const [openMessage, setOpenMessage] = useState(false)
  const onCloseMessage = () => { setOpenMessage(!openMessage); }
  const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
  const dispatch = useDispatch();
  const params = useParams();
  // El terapeuta registra sus propias sesiones con sesionTerapeuta.editar y la
  // supervision edita cualquiera con sesion.editar: basta con tener una de las
  // dos llaves.
  const { isReadOnly, setIsReadOnly } = useMantenimiento(["sesion", "sesionTerapeuta"]);
  // Una sesion validada ya no se puede modificar.
  const bloqueada = session.idEstadoValidacion === 310;
  const readOnly = isReadOnly || bloqueada;
  // La flecha hacia abajo de una fila del detalle del plan agrega un criterio
  // con el modelo y el area de esa fila.
  const agregarCriterioDesdePlan = (detalle) => {
    dispatch(addSessionCriterionDesdePlan(detalle));
  }

  const postEntity = async () => {
    // Los criterios se mandan con lo que el servicio necesita de la vista. Los
    // autocompletados aceptan texto libre, asi que tambien se manda el texto
    // escrito cuando no se eligio uno del catalogo: con eso el API registra el
    // objetivo o el criterio nuevo.
    var dataPost = {
      ...session
      , sesionTerapeuta: sessionTherapist
      , sesionCriterio: (sessionCriterion || []).map((row) => ({
          id: row.id,
          numero: row.numero,
          idAreaObjetivoCriterio: row.idAreaObjetivoCriterio,
          idPuntuacionGrupo: row.idPuntuacionGrupo,
          idArea: row.idArea,
          idAreaObjetivo: row.idAreaObjetivo,
          objetivoNuevo: (row.idAreaObjetivo > 0 ? "" : (row.objetivo || "")),
          criterioNuevo: (row.idAreaObjetivoCriterio > 0 ? "" : (row.criterio || "")),
            detalle: row.detalle || "",
      }))
    }

    var ValidationMessages = sessionValidation.concat(sessionTherapistValidation).concat(sessionCriterionValidation);

    if (ValidationMessages.length > 0) {
      dispatch(activeValidationsSession());
      dispatch(activeSessionTherapist());
      dispatch(activeSessionCriterion());

      setPropsMessage({ severity: "error", message: ValidationMessages.join(" - ") })
      setOpenMessage(true);
    }
    else {
      await sesionService.addUpdateSessionWithDetails(dataPost)
        .then(response => {
          setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" })
          setOpenMessage(true);
          setIsReadOnly(true);

          if (session.id > 0){
            sesionService.getsSesionTerapeutaView(session.id)
            .then(data => {
              if (data === null || data.length === 0)
                dispatch(setSessionTherapist(defaultSessionTherapist));
              else
                dispatch(setSessionTherapist(data));
            })
            .catch((err) => {
              console.log("Err: ", err);
            });

            sesionService.getsSesionCriterioView(session.id)
            .then((data) => {
                if (data == null || data.length == 0){
                    dispatch(setSessionCriterion(defaultSessionCriterion));
                }
                else {
                    dispatch(setSessionCriterion(data));
                }
            })
            .catch((err) => {
                console.log("Err: ", err)
            });
          }
        })
        .catch(error => {
          // Si el API rechazo los datos (por ejemplo, fecha y hora ya
          // ocupadas en el terapia periodo), el motivo viene en detail.
          setPropsMessage({ severity: "error", message: error.response?.data?.detail || "Hubo un error" })
          setOpenMessage(true);
        });
    }
  }

  return (
    <div>
      <MantenimientoForm
        title={(params.id == 0 ? "Nueva" : "Editar") + " Sesion"}
        backTo={"/session/0"}
        onSave={postEntity}
        disabled={readOnly}
      >
        <Box sx={{ fontWeight: 'bold' }} padding={0}>
          <Typography variant="h7">
            {nombreTerapeuta}
          </Typography>
        </Box>
        {bloqueada && (
          <Box sx={{ padding: "4px 0px 0px 0px" }}>
            <Typography variant="caption" color="warning.main">
              Sesion validada: ya no se puede modificar.
            </Typography>
          </Box>
        )}

        <Grid container spacing={1} sx={{
          "& .MuiGrid-root>.MuiGrid-item": {
            paddingTop: "8px"
          },
        }}>
          <Grid item xs={12} sm={12}>
            <Card >
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <Session isReadOnly={readOnly} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <SessionPlanArea idTerapia={idTerapia} idPeriodo={idPeriodo} isReadOnly={readOnly}
                  onAgregarCriterio={agregarCriterioDesdePlan}
                  onEscalaAvance={setIdPuntuacionSesion}
                  onDetalle={(detObjetivo, detCriterio) => setDetallePlan({ detObjetivo, detCriterio })} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <SessionCriterion isReadOnly={readOnly} idPuntuacionPlan={idPuntuacionSesion}
                  detObjetivoPlan={detallePlan.detObjetivo}
                  detCriterioPlan={detallePlan.detCriterio} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <SessionTherapist isReadOnly={readOnly} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </MantenimientoForm>
      <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
        anchorOrigin={{vertical: "top", horizontal: "center"}}>
        <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
          {propsMessage.message}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default Edit
